import { debounce } from 'lodash';
import { TDispatch } from '../../../../../../../../../common/types/dispatch';
import { changeCurrentBet, TChangeCurrentBetSource } from '../../../../../../../../thunks/auction';

export const saveBetToStore = debounce(
  (dispatch: TDispatch, bet: number, source: TChangeCurrentBetSource) => dispatch(changeCurrentBet({ bet, source })),
  700,
);
